// CsvExportMenuItemWithIcon.tsx
import * as React from "react";

import TableViewOutlinedIcon from "@mui/icons-material/TableViewOutlined";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid";

type CsvOptions = {
	fileName?: string;
	delimiter?: string;
	includeHeaders?: boolean;
	utf8WithBom?: boolean;
};

export function CsvExportMenuItemWithIcon({
	options,
	icon = <TableViewOutlinedIcon fontSize="small" />,
	label = "CSV (.csv)",
	secondary = "Comma-separated file",
}: {
	options?: CsvOptions;
	icon?: React.ReactNode;
	label?: React.ReactNode;
	secondary?: React.ReactNode;
}) {
	const apiRef = useGridApiContext();

	const handleClick = () => {
		// Built-in export if available
		// @ts-expect-error MUI grid export is version-dependent on the API ref.
		if (apiRef.current.exportDataAsCsv) {
			// @ts-expect-error MUI grid export is version-dependent on the API ref.
			apiRef.current.exportDataAsCsv(options);
		} else {
			// Fallback: publish a custom event you can handle elsewhere if needed
			apiRef.current.publishEvent?.("csvExport", options);
		}
	};

	return (
		<MenuItem onClick={handleClick}>
			<ListItemIcon>{icon}</ListItemIcon>
			<ListItemText
				primary={label}
				secondary={secondary}
				primaryTypographyProps={{ fontWeight: 600 }}
			/>
		</MenuItem>
	);
}
